import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { get, isString, isEmpty } from 'lodash';
var supportedLocales = ['pt', 'es', 'fr', 'de', 'ru', 'it', 'ja'];
export var IndustryService = /*#__PURE__*/function () {
  function IndustryService(locale, httpClient) {
    this._httpClient = httpClient;
    this.locale = locale && supportedLocales.indexOf(locale) > -1 ? locale : 'en';
    this.extractIndustryDataFromId = this.extractIndustryDataFromId;
  }

  var _proto = IndustryService.prototype;

  _proto.getIndustryById = /*#__PURE__*/function () {
    var _getIndustryById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(industryId, structureId) {
      var industriesData, industry;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getIndustries();

            case 2:
              industriesData = _context.sent;
              industry = industriesData.industries.find(function (industry) {
                return industry.industryId === industryId && industry.structureId === structureId;
              });

              if (industry) {
                industry.valid = true;
              }

              return _context.abrupt("return", industry);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function getIndustryById(_x, _x2) {
      return _getIndustryById.apply(this, arguments);
    }

    return getIndustryById;
  }();

  _proto.extractIndustryDataFromId = function extractIndustryDataFromId(industryId) {
    if (!industryId) {
      return;
    }

    var arrIndustry = String(industryId).split('_');

    if (arrIndustry.length !== 3) {
      return;
    }

    var isIndustryValid = arrIndustry[0] !== 'null';
    var isStructureValid = arrIndustry[1] !== 'null';
    return {
      industryId: isIndustryValid ? arrIndustry[0] : null,
      structureId: isStructureValid ? arrIndustry[1] : null,
      valid: isIndustryValid && isStructureValid,
      label: arrIndustry[2]
    };
  };

  _proto.getIndustryTagsById = /*#__PURE__*/function () {
    var _getIndustryTagsById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(industryId, structureId) {
      var tags, industriesData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              tags = [];
              _context2.next = 3;
              return this.getIndustryById(industryId, structureId);

            case 3:
              industriesData = _context2.sent;

              if (industriesData) {
                tags = industriesData.tags || [];
              }

              return _context2.abrupt("return", tags.map(function (tag) {
                return tag.trim();
              }));

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function getIndustryTagsById(_x3, _x4) {
      return _getIndustryTagsById.apply(this, arguments);
    }

    return getIndustryTagsById;
  }();

  _proto._getSuggestionsForIndustryTerm = function _getSuggestionsForIndustryTerm(term) {
    if (!term) {
      return;
    }

    return this._httpClient.get('/v1/categories', {
      params: {
        q: term,
        locale: this.locale,
        source: 'logo'
      }
    }).then(function (response) {
      return response.data;
    })["catch"](function (e) {
      console.error(e);
      return false;
    });
  };

  _proto.getIndustrySuggestions = /*#__PURE__*/function () {
    var _getIndustrySuggestions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(term) {
      var _yield$Promise$all, industries, suggestions, all, picked, matched, filtered;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return Promise.all([this.getIndustries(), this._getSuggestionsForIndustryTerm(term)]);

            case 2:
              _yield$Promise$all = _context3.sent;
              industries = _yield$Promise$all[0].industries;
              suggestions = _yield$Promise$all[1];
              all = suggestions ? suggestions.results.concat(suggestions.relatedResults) : [];

              if (!(!all || !all.length)) {
                _context3.next = 8;
                break;
              }

              return _context3.abrupt("return");

            case 8:
              picked = all.reduce(function (allWithKeys, val) {
                var key = (val.industryId + "_" + val.structureId + "_" + val.displayName).toLowerCase();
                allWithKeys[key] = val;
                return allWithKeys;
              }, {});
              matched = Object.keys(picked).map(function (id) {
                var existingIndustry = industries.find(function (industry) {
                  return (industry.industryId + "_" + industry.structureId + "_" + industry.label).toLowerCase() === id;
                }) || {};
                var newIndustry = picked[id];
                return {
                  id: id,
                  industryId: newIndustry && newIndustry.industryId,
                  structureId: newIndustry && newIndustry.structureId,
                  label: get(existingIndustry, 'label') || newIndustry && newIndustry.displayName,
                  LogoCat: '',
                  tags: get(existingIndustry, 'tags', [])
                };
              });
              filtered = matched.filter(function (x) {
                return x;
              });
              return _context3.abrupt("return", filtered);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function getIndustrySuggestions(_x5) {
      return _getIndustrySuggestions.apply(this, arguments);
    }

    return getIndustrySuggestions;
  }();

  _proto.getIndustryData = function getIndustryData(industry) {
    var isCustom = industry.isCustom;
    var industryData,
        industryId = industry == null ? void 0 : industry.industryId,
        structureId = industry == null ? void 0 : industry.structureId,
        label = industry == null ? void 0 : industry.industryName;

    if (!isCustom && industry && isString(industry.industry) && !isEmpty(industry.industry)) {
      industryData = this.extractIndustryDataFromId(industry.industry);
      industryId = industryData.industryId;
      structureId = industryData.structureId;
      label = industryData.label;
    }

    return {
      isCustom: isCustom,
      industryId: industryId,
      structureId: structureId,
      label: label
    };
  };

  return IndustryService;
}();